import RomyIcon from '../RomyIcon';

export default function LoadingDots() {
  return (
    <div className="flex items-center justify-start">
      <div className="hidden md:block flex-shrink-0 mr-3 text-pink-500">
        <RomyIcon size={22} />
      </div>
      <div>
        <div className="md:hidden mb-1.5 text-pink-500">
          <RomyIcon size={22} />
        </div>
        <div className="flex items-center space-x-1">
          <div
            className="w-2 h-2 bg-pink-500 rounded-full animate-bounce"
            style={{ animationDelay: '0ms' }}
          />
          <div
            className="w-2 h-2 bg-pink-500 rounded-full animate-bounce"
            style={{ animationDelay: '150ms' }}
          />
          <div
            className="w-2 h-2 bg-pink-500 rounded-full animate-bounce"
            style={{ animationDelay: '300ms' }}
          />
        </div>
      </div>
    </div>
  );
}
